import { defineComponent as _defineComponent } from 'vue'
import {
    computed,
    onMounted,
    provide,
    shallowRef,
    unref,
    watch,
} from 'vue';

import type {
    IdRef,
    NavTabsParent,
    TabButtonProps,
    TabPaneType,
} from './injection';
import { NavTabsParentKey } from './injection';
import TabButton from './tab-button.vue';

//valueProp, it cannot handle dynamic ones

export default /*#__PURE__*/_defineComponent({
  __name: 'nav-tabs',
  props: {
    modelValue: null,
    tabsClass: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue?: string;
    tabsClass?: string;
}


//eslint-disable-next-line no-spaced-func

let activeTab: string | undefined;

const panes = new Map<string, TabPaneType>();
const panesArray = shallowRef<TabPaneType[]>([]);

function updatePanes() {
    const _panesArray: TabPaneType[] = [...panes.values()];
    _panesArray.sort((a, b) => a.index - b.index);
    panesArray.value = _panesArray;
}

const tabsParent: NavTabsParent = {
    registerPane(pane) {
        panes.set(pane.idRef.id, pane);
        updatePanes();
    },
    updatePane(idRef, index) {
        const paneDef = panes.get(idRef.id);
        if(paneDef) {
            paneDef.index = index;
            updatePanes();
        }
    },
    unregisterPane(idRef) {
        panes.delete(idRef.id);
        updatePanes();
    },
};
provide(NavTabsParentKey, tabsParent);

function activateTab() {
    for(const pane of panes.values()) {
        //will affect buttons too
        pane.active.value = (pane.idRef.id === activeTab);
    }
}
function onTabActivate(idRef: IdRef) {
    activeTab = idRef.id;
    activateTab();
    emit('update:modelValue', activeTab);
}

watch(() => props.modelValue, (value) => {
    if(activeTab !== value) {
        activeTab = value;
        activateTab();
    }
});

onMounted(() => {
    if(props.modelValue) {
        activeTab = props.modelValue;
        activateTab();
    } else {
        for(const pane of panes.values()) {
            //simulate activation for first initiallyActive
            if(unref(pane.active)) {
                onTabActivate(pane.idRef);
                break;
            }
        }
    }
});

const buttonsArray = computed(() => {
    const _panesArray = unref(panesArray);
    const _buttons = _panesArray.map((pane) => {
        const buttonProps: TabButtonProps = {
            active: unref(pane.active),
            title: pane.props.title,
            idRef: pane.idRef,
            visible: unref(pane.visible),
        };
        return {
            props: {
                ...buttonProps,
                key: pane.idRef.id || pane.index,
            },
            on: {
                activate: onTabActivate,
            },
        };
    });
    return _buttons;
});

return { __sfc: true,props, emit, activeTab, panes, panesArray, updatePanes, tabsParent, activateTab, onTabActivate, buttonsArray, TabButton }
}

})